import { SocialCategoryModel } from '@models/social-category/social-category.model';

export enum PaymentType {
  WALLET = 'wallet',
  SALARY = 'salary',
  ADVANTAGE = 'advantage',
}

export interface UserCompanyDataModel {
  id: number;
  professional_social_category: SocialCategoryModel;
  is_can_book: boolean;
  max_invite: number | null;
  payment_type: PaymentType | null;
}
